import * as d3 from 'd3'

export default {

  methods: {

    draw_Donuts() {

      let cir = this.circle
      let title = this.title

      let Table = this.canvasForms
      .append('g')
      .attr('transform', `translate(${cir.x}, ${cir.y})`)

      let cx = cir.radius

      this.columns.forEach((d,i)=> {
        let data_ = this.rawData[d.code]

        let endAn = ''
        let arc = d3.arc()
        .outerRadius(cir.radius)
        .innerRadius(cir.radius - cir.thickness)
        .startAngle(Math.PI / 180)
        .endAngle(() => endAn || 360 * Math.PI / 180)

        let chart = Table
        .append('g')
        .attr('transform', `translate(${cx}, ${cir.radius})`)
        .call(this.event_Link, d)

  
        if(data_ == 0){
          chart
          .append('path')
          .attr('d', arc).attr('fill', cir.bColor).attr('opacity', cir.bOpacity)
          .attr('stroke', cir.sColor).attr('stroke-width', cir.sWidth)          
        }else{
          chart
          .append('path')
          .attr('d', arc).attr('fill', cir.fColor).attr('opacity', cir.fOpacity)
          .attr('stroke', cir.sColor).attr('stroke-width', cir.sWidth)
          .transition()
          .duration(300)
          .attrTween('d', ()=> {
            let endAngle_ = ( ((360 * (data_/100)) ) * Math.PI / 180)
            let interpolate = d3.interpolate(360 * Math.PI / 180, endAngle_)
            return function(t) {
              endAn = interpolate(t)
              return arc()
            }
          })

          chart
          .append('path')
          .attr('d', arc).attr('fill', cir.bColor).attr('opacity', cir.bOpacity)
          .transition()
          .duration(0)
          .attrTween('d', ()=> {
            let endAngle_ = ( ((-360 * ((100-data_)/100)) ) * Math.PI / 180)
            let interpolate = d3.interpolate(360 * Math.PI / 180, endAngle_)
            return function(t) {
              endAn = interpolate(t)
              return arc()
            }
          })
        }

        chart
        .append('circle')
        .attr('cx', 0).attr('cy', 0).attr('r', cir.radius)
        .attr('fill', 'red').attr('opacity', 0)
        
        // Value
        chart
        .append('text')
        .attr('x', 0).attr('y', d.tSize*0.4)
        .attr('fill', d.tColor).attr('font-size', d.tSize)
        .attr('text-anchor', 'middle')
        .text(data_ + d.unit)

        // Title
        chart
        .append('text')
        .attr('x', 0).attr('y', cir.radius + title.padding + title.tSize*0.4)
        .attr('fill', title.tColor).attr('font-size', title.tSize)
        .attr('text-anchor', 'middle')
        .text(d.name)

        cx = cx + (cir.space + (cir.radius*2))
      })

    },

  } 
}